import { FC } from "react";
import { Modal } from "react-bootstrap";

type Props = {
  show: boolean;
  handleClose: any;
};

const PaymentModal: FC<Props> = ({ show, handleClose }) => {
  return (
    <Modal
      className="order_option_popup"
      show={show}
      onHide={handleClose}
      fullscreen="sm-down"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Card Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="Profile_sec">
          <div className="Profile_main p-0 border-0 shadow-none">
            <label>Name on the Card</label>
            <input
              type="text"
              placeholder="Enter the credit card holder name"
            />

            <label>Card Number</label>
            <input type="text" placeholder="Enter the 16 digit card number" />

            <div className="row row1">
              <div className="col-12 col-md-8">
                <label>Expire Date</label>
                <input type="text" placeholder="MM/YYYY" />
              </div>
              <div className="col-12 col-md-4">
                <label>CVV</label>
                <input type="text" placeholder="" />
              </div>
            </div>
            <label>Billing Zip code </label>
            <input
              type="text"
              placeholder="Enter the billing zip code number"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" onClick={handleClose}>
          Add card
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentModal;
